import "./hb-silver.module.css";
import { html } from "lit-html";
import { isPopup, getName } from "../../global";

const hb = new URL("../../../public/hb.svg", import.meta.url).href;

export default (user) => html`
    <div
        id="hb-silver"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <button
                        type="button"
                        id="hb-silver-back"
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        <span class="mr-2">⬅</span>
                        <!--<span class="${user
                            ? ""
                            : "hidden"} mr-2">⬅</span>-->
                        Heart
                        <svg
                            id="hb-silver-heartbeat"
                            class="${user
                                ? "animate-heartbeat"
                                : ""} -ml-2 -mr-1 mt-[-3px] w-7 h-7 inline-flex"
                            fill="silver"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        ank® Silver
                        <!--ℹ️ TODO:-->
                    </button>
                    <aside>
                        <button
                            type="button"
                            id="hb-silver-stamp"
                            class="hidden mr-2">
                            <svg
                                class="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 448 512">
                                <path
                                    d="M64 160l64 0 0-64-64 0 0 64zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 416l64 0 0-64-64 0 0 64zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM320 96l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM288 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm32-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-32 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z" />
                            </svg>
                        </button>
                        <button
                            type="button"
                            class="${isPopup
                                ? "hidden"
                                : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="hb-silver">
                            <svg
                                class="w-4 h-4"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 384 512">
                                <path
                                    d="M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z" />
                            </svg>
                            <span class="sr-only">Close</span>
                        </button>
                    </aside>
                </div>
                <!-- Modal body -->
                <form
                    id="hb-silver-mint"
                    class="p-4 space-y-4 text-base leading-loose text-gray-900 dark:text-white">
                    <div class="grid gap-6 mb-6">
                        <div>
                            <label
                                for="hb-silver-from"
                                class="inline-flex justify-between w-full mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <aside>
                                    <button
                                        data-popover-target="hb-silver-from-info"
                                        data-popover-placement="bottom-end"
                                        type="button">
                                        From ℹ️
                                        <span class="sr-only"
                                            >Show information
                                        </span>
                                    </button>
                                    <div
                                        data-popover
                                        id="hb-silver-from-info"
                                        role="tooltip"
                                        class="absolute z-50 invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-xs opacity-0 w-72 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400">
                                        <div class="p-3 space-y-2">
                                            <iframe
                                                loading2="lazy"
                                                class="w-full h-auto"
                                                data-src="https://www.youtube.com/embed/sRE8Rx-rOKY?si=cialbMQStNL-1YTn&controls=1&enablejsapi=1"
                                                title="YouTube video player"
                                                frameborder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                referrerpolicy="strict-origin-when-cross-origin"
                                                allowfullscreen></iframe>
                                            <h3
                                                class="font-semibold text-gray-900 dark:text-white">
                                                From
                                            </h3>
                                            <p
                                                id="hb-silver-from-footnote"
                                                class="${user ? "hidden" : ""}">
                                                Rotate your
                                                <!--${user
                                                    ? "Safe"
                                                    : "Locker"}-->
                                                often to protect your privacy.
                                            </p>
                                            <a
                                                href2="#"
                                                class="flex items-center font-medium text-blue-600 dark:text-blue-500 dark:hover:text-blue-600 hover:text-blue-700 hover:underline"
                                                >Watch on YouTube
                                                <svg
                                                    class="w-2 h-2 ms-1.5 rtl:rotate-180"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 6 10">
                                                    <path
                                                        stroke="currentColor"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="m1 9 4-4-4-4" />
                                                </svg>
                                            </a>
                                        </div>
                                        <div data-popper-arrow></div>
                                    </div>
                                </aside>
                                <aside>
                                    <span id="hb-silver-from-icon">
                                        <!--${user ? "🔒" : "🔐"}-->
                                    </span>
                                    <span class="${user ? "hidden" : ""}">
                                        Lockers
                                    </span>
                                    <select
                                        id="hb-silver-from"
                                        class="${user
                                            ? "inline"
                                            : "hidden"} p-0 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                        <option value="safe" .selected=${user}>
                                            Safes
                                        </option>
                                        <option
                                            value="locker"
                                            .selected=${!user}>
                                            Lockers
                                        </option>
                                    </select>
                                </aside>
                                <!--<label
                                    class="${user
                                    ? "inline-flex"
                                    : "hidden"} items-center cursor-pointer">
                                    <span
                                        id="hb-silver-from-label"
                                        class="mr-3 text-sm font-medium text-gray-900 dark:text-gray-300"
                                        >Stored</span
                                    >
                                    <input
                                        id="hb-silver-from-checkbox"
                                        type="checkbox"
                                        value=""
                                        .checked=${user}
                                        class="sr-only peer" />
                                    <div
                                        class="relative outline-0 w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
                                </label>-->
                            </label>
                            <div
                                id="hb-silver-from-locker-always"
                                class="${user ? "hidden" : "flex"}">
                                <span
                                    class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600">
                                    <svg
                                        class="w-5 h-5 text-gray-500 dark:text-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 640 640">
                                        <path
                                            d="M415.9 344L225 344C227.9 408.5 242.2 467.9 262.5 511.4C273.9 535.9 286.2 553.2 297.6 563.8C308.8 574.3 316.5 576 320.5 576C324.5 576 332.2 574.3 343.4 563.8C354.8 553.2 367.1 535.8 378.5 511.4C398.8 467.9 413.1 408.5 416 344zM224.9 296L415.8 296C413 231.5 398.7 172.1 378.4 128.6C367 104.2 354.7 86.8 343.3 76.2C332.1 65.7 324.4 64 320.4 64C316.4 64 308.7 65.7 297.5 76.2C286.1 86.8 273.8 104.2 262.4 128.6C242.1 172.1 227.8 231.5 224.9 296zM176.9 296C180.4 210.4 202.5 130.9 234.8 78.7C142.7 111.3 74.9 195.2 65.5 296L176.9 296zM65.5 344C74.9 444.8 142.7 528.7 234.8 561.3C202.5 509.1 180.4 429.6 176.9 344L65.5 344zM463.9 344C460.4 429.6 438.3 509.1 406 561.3C498.1 528.6 565.9 444.8 575.3 344L463.9 344zM575.3 296C565.9 195.2 498.1 111.3 406 78.7C438.3 130.9 460.4 210.4 463.9 296L575.3 296z" />
                                    </svg>
                                </span>
                                <label
                                    for="hb-silver-from-locker-keys-always"
                                    class="sr-only"
                                    >Choose Locker Address</label
                                >
                                <select
                                    id="hb-silver-from-locker-keys-always"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-base rounded-e-lg border-s-gray-100 dark:border-s-gray-700 border-s-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"></select>
                            </div>
                            <ul
                                id="hb-silver-from-locker"
                                class="${user
                                    ? "hidden"
                                    : ""} items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg flex-col dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                <li
                                    class="w-full border-gray-200 border-b border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            id="hb-silver-from-locker-public"
                                            type="radio"
                                            value="public"
                                            name="hb-silver-from-locker"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-silver-from-locker-public"
                                            class="w-full flex items-center justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <span class="ml-1">Public</span>
                                            <aside
                                                id="hb-silver-from-locker-avatar"
                                                class="mr-4 flex items-center">
                                                <!--${user?.photoURL
                                                    ? html`<img
                                                          src="${user.photoURL}"
                                                          class="w-5 h-5 rounded-full" />`
                                                    : ""}
                                                <span class="ml-2">
                                                    ${getName(false)}
                                                </span>-->
                                            </aside>
                                        </label>
                                    </div>
                                </li>
                                <li
                                    class="w-full border-gray-200 border-b-0 border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            id="hb-silver-from-locker-anonymous"
                                            type="radio"
                                            value="anonymous"
                                            name="hb-silver-from-locker"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-silver-from-locker-anonymous"
                                            class="w-full inline-flex align-middle justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <span class="p-0 ml-1">
                                                Anonymous
                                            </span>
                                            <aside>
                                                <span>🔐</span>
                                                <select
                                                    id="hb-silver-from-locker-keys"
                                                    class="mr-3 p-0 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"></select>
                                            </aside>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                            <div
                                id="hb-silver-from-safe-always"
                                class="${user ? "flex" : "hidden"}">
                                <span
                                    class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600">
                                    <svg
                                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 640 640">
                                        <path
                                            d="M415.9 344L225 344C227.9 408.5 242.2 467.9 262.5 511.4C273.9 535.9 286.2 553.2 297.6 563.8C308.8 574.3 316.5 576 320.5 576C324.5 576 332.2 574.3 343.4 563.8C354.8 553.2 367.1 535.8 378.5 511.4C398.8 467.9 413.1 408.5 416 344zM224.9 296L415.8 296C413 231.5 398.7 172.1 378.4 128.6C367 104.2 354.7 86.8 343.3 76.2C332.1 65.7 324.4 64 320.4 64C316.4 64 308.7 65.7 297.5 76.2C286.1 86.8 273.8 104.2 262.4 128.6C242.1 172.1 227.8 231.5 224.9 296zM176.9 296C180.4 210.4 202.5 130.9 234.8 78.7C142.7 111.3 74.9 195.2 65.5 296L176.9 296zM65.5 344C74.9 444.8 142.7 528.7 234.8 561.3C202.5 509.1 180.4 429.6 176.9 344L65.5 344zM463.9 344C460.4 429.6 438.3 509.1 406 561.3C498.1 528.6 565.9 444.8 575.3 344L463.9 344zM575.3 296C565.9 195.2 498.1 111.3 406 78.7C438.3 130.9 460.4 210.4 463.9 296L575.3 296z" />
                                    </svg>
                                </span>
                                <label
                                    for="hb-silver-from-safe-keys-always"
                                    class="sr-only"
                                    >Choose Safe Address</label
                                >
                                <select
                                    id="hb-silver-from-safe-keys-always"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-base rounded-e-lg border-s-gray-100 dark:border-s-gray-700 border-s-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"></select>
                            </div>
                            <ul
                                id="hb-silver-from-safe"
                                class="${user
                                    ? ""
                                    : "hidden"} items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg flex-col dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                <li
                                    class="w-full border-gray-200 border-b border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            id="hb-silver-from-safe-public"
                                            type="radio"
                                            value="public"
                                            name="hb-silver-from-safe"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-silver-from-safe-public"
                                            class="w-full flex items-center justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <span class="ml-1">Public</span>
                                            <aside
                                                id="hb-silver-from-safe-avatar"
                                                class="mr-4 flex items-center">
                                                <!--${user?.photoURL
                                                    ? html`<img
                                                          src="${user.photoURL}"
                                                          class="w-5 h-5 rounded-full" />`
                                                    : ""}
                                                <span class="ml-2">
                                                    ${getName()}
                                                </span>-->
                                            </aside>
                                        </label>
                                    </div>
                                </li>
                                <li
                                    class="w-full border-gray-200 border-b-0 border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            id="hb-silver-from-safe-anonymous"
                                            type="radio"
                                            value="anonymous"
                                            name="hb-silver-from-safe"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-silver-from-safe-anonymous"
                                            class="w-full inline-flex align-middle justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <span class="p-0 ml-1">
                                                Anonymous
                                            </span>
                                            <aside>
                                                <span>🔒</span>
                                                <select
                                                    id="hb-silver-from-safe-keys"
                                                    class="mr-3 p-0 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"></select>
                                            </aside>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                            <!--<p
                                id="hb-silver-from-footnote"
                                class="${user
                                ? "hidden"
                                : ""} mt-2 text-gray-400 text-xs text-left">
                                Rotate your ${user ? "Safe" : "Locker"}
                                often to protect your privacy.
                            </p>-->
                        </div>
                        <div>
                            <label
                                for="hb-silver-to"
                                class="inline-flex justify-between w-full mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                To ℹ️
                                <!--<aside class="${user ? "" : "hidden"}">
                                    🔐
                                    <select
                                        id="hb-silver-to"
                                        class="inline p-0 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                        <option value="safe">Safes</option>
                                        <option
                                            value="locker"
                                            ${user ? "selected" : ""}>
                                            Lockers
                                        </option>
                                    </select>
                                </aside>-->
                                <label
                                    class="inline-flex items-center cursor-pointer">
                                    <span
                                        id="hb-silver-to-label"
                                        class="mr-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        Private
                                    </span>
                                    <input
                                        id="hb-silver-to-checkbox"
                                        type="checkbox"
                                        value=""
                                        class="sr-only peer outline-0" />
                                    <div
                                        class="relative w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
                                </label>
                            </label>
                            <div
                                id="hb-silver-to-locker"
                                class="${user ? "hidden" : "flex"} relative">
                                <span
                                    class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600">
                                    <svg
                                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
                                    </svg>
                                </span>
                                <input
                                    type="text"
                                    autocomplete=""
                                    id="hb-silver-to-kid"
                                    class="rounded-none outline-0 rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-base border-gray-300 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Enter Locker or Safe" />
                                <button
                                    id="hb-silver-to-kid-add"
                                    type="button"
                                    class="absolute inset-y-0 end-0 flex items-center pe-3">
                                    <svg
                                        class="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 448 512">
                                        <path
                                            stroke="currentColor"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                                    </svg>
                                </button>
                            </div>
                            <div
                                id="hb-silver-to-safe"
                                class="${user ? "flex" : "hidden"}">
                                <label
                                    for="hb-silver-to-dropdown"
                                    class="sr-only mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    Locker or Safe Address
                                </label>
                                <button
                                    data-dropdown-toggle="hb-silver-to-menu"
                                    class="shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600"
                                    type="button">
                                    <span id="hb-silver-to-dropdown">
                                        Username
                                    </span>
                                    <svg
                                        class="w-2.5 h-2.5 ms-2.5"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 10 6">
                                        <path
                                            stroke="currentColor"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="m1 1 4 4 4-4" />
                                    </svg>
                                </button>
                                <div
                                    id="hb-silver-to-menu"
                                    class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-fit dark:bg-gray-700">
                                    <ul
                                        class="py-2 text-sm text-gray-700 dark:text-gray-200"
                                        aria-labelledby="hb-silver-to-menu">
                                        <li class="hidden">
                                            <button
                                                id="hb-silver-to-menu-crew"
                                                type="button"
                                                class="inline-flex w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                Family Crew
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                id="hb-silver-to-menu-username"
                                                type="button"
                                                class="inline-flex w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                Username
                                            </button>
                                        </li>
                                        <li class="hidden">
                                            <button
                                                id="hb-silver-to-menu-email"
                                                type="button"
                                                class="inline-flex w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                Email
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                id="hb-silver-to-menu-kid"
                                                type="button"
                                                class="inline-flex w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                Address
                                            </button>
                                        </li>
                                        <li class="hidden">
                                            <button
                                                id="hb-silver-to-menu-me"
                                                type="button"
                                                class="inline-flex w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                My Self
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                <div class="relative w-full">
                                    <input
                                        data-dropdown-toggle2="hb-silver-to-heroes"
                                        autocomplete="off"
                                        type="text"
                                        id="hb-silver-to-search"
                                        class="block outline-0 p-2.5 w-full z-20 text-base text-gray-900 bg-gray-50 rounded-e-lg border-s-gray-50 border-s-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-s-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                                        placeholder="Search Zero Hero" />
                                    <button
                                        id="hb-silver-to-search-add"
                                        type="button"
                                        class="absolute inset-y-0 end-0 items-center pe-3">
                                        <svg
                                            class="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="currentColor"
                                            viewBox="0 0 448 512">
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                                        </svg>
                                    </button>
                                    <!--<button
                                        type="button"
                                        class="hidden absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-blue-700 rounded-e-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                        <svg
                                            class="w-4 h-4"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 20 20">
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                        </svg>
                                        <span class="sr-only">Search</span>
                                    </button>-->
                                    <div
                                        id="hb-silver-to-heroes"
                                        class="z-10 overflow-y-scroll h-52 hidden absolute bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-full dark:bg-gray-700 dark:divide-gray-600">
                                        <ul
                                            class="p-3 space-y-1 text-sm text-gray-700 dark:text-gray-200"
                                            aria-labelledby="hb-silver-to-search"></ul>
                                    </div>
                                </div>
                            </div>
                            <ul
                                id="hb-silver-to-recipients"
                                class="w-full mt-5 text-gray-900 bg-white border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                <li
                                    id="hb-silver-to-none"
                                    class="text-gray-400 text-sm text-center">
                                    Everyone will be able to view your Silver.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <label
                                for="hb-silver-message"
                                class="w-full inline-flex justify-between align-middle mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <span id="hb-silver-message-label">
                                    🩶 Silver ℹ️
                                </span>
                                <div>
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-silver-message-save">
                                        💾
                                    </button>
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-silver-message-undo">
                                        ↩️
                                    </button>
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-silver-message-paste">
                                        📋
                                    </button>
                                    <button
                                        type="button"
                                        id="hb-silver-message-trash">
                                        🗑️
                                    </button>
                                    <span
                                        id="hb-silver-message-counter"
                                        class="hidden ml-5">
                                        <span></span>
                                        <span>/</span>
                                        <span></span>
                                    </span>
                                </div>
                            </label>
                            <section class="relative">
                                <textarea
                                    required
                                    id="hb-silver-message"
                                    rows="4"
                                    class="block outline-0 p-2.5 w-full h-40 text-lg text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="What public ${user
                                        ? "message"
                                        : "note"} would you like to engrave on your Silver?">
${localStorage.getItem("silver") || ""}</textarea
                                >
                                <button
                                    class="absolute bottom-0 left-2"
                                    type="button"
                                    id="hb-silver-message-record">
                                    🎙️
                                </button>
                                <button
                                    class="absolute bottom-0 right-2"
                                    type="button"
                                    id="hb-silver-message-magic">
                                    🪄
                                </button>
                            </section>
                            <p
                                id="hb-silver-message-footnote"
                                class="hidden mt-2 text-gray-400 text-xs text-left"></p>
                        </div>
                        <div id="hb-silver-voice" class="hidden">
                            <div
                                class="hidden w-full mb-5 bg-gray-200 rounded-full dark:bg-gray-500">
                                <div
                                    id="hb-silver-voice-progress"
                                    class="bg-green-600 text-xs font-medium text-green-100 text-center p-0.5 leading-none rounded-full"
                                    style="width: 45%">
                                    45%
                                </div>
                            </div>
                            <audio
                                id="hb-silver-voice-audio"
                                controls
                                playsinline
                                controlsList="nofullscreen"
                                preload="auto"
                                disableRemotePlayback
                                class="hidden mb-5 w-full"></audio>
                            <video
                                id="hb-silver-voice-video"
                                controls
                                playsinline
                                controlsList="nofullscreen"
                                poster="${hb}"
                                preload="auto"
                                disablePictureInPicture
                                disableRemotePlayback
                                class="hidden mb-5 w-full"></video>
                            <div class="inline-flex w-full">
                                <button
                                    id="hb-silver-voice-attach"
                                    type="button"
                                    class="w-full px-3 py-2 text-sm font-medium text-center inline-flex items-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                    <svg
                                        class="w-4 h-4 text-white me-3"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M64 96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 288 96 0 0-128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-288-96 0 0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-128z" />
                                    </svg>
                                    Attach Voice
                                </button>
                                <button
                                    id="hb-silver-voice-microphone"
                                    type="button"
                                    class="ml-3 w-10 px-3 py-2 text-sm font-medium text-center items-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                    <svg
                                        class="w-4 h-4 text-white"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 384 512">
                                        <path
                                            d="M192 0C139 0 96 43 96 96l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-53-43-96-96-96zM48 184c0-13.3-10.7-24-24-24S0 170.7 0 184l0 40c0 97.9 73.3 178.7 168 190.5l0 49.5-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-49.5c94.7-11.8 168-92.6 168-190.5l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 79.5-64.5 144-144 144S48 303.5 48 224l0-40z" />
                                    </svg>
                                </button>
                                <button
                                    id="hb-silver-voice-stop"
                                    type="button"
                                    class="hidden ml-3 w-10 px-3 py-2 text-sm font-medium text-center items-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                                    <svg
                                        class="w-4 h-4 text-white"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM192 160l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z" />
                                    </svg>
                                </button>
                                <button
                                    id="hb-silver-voice-camcorder"
                                    type="button"
                                    class="ml-3 w-10 px-3 py-2 text-sm font-medium text-center items-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                    <svg
                                        class="w-4 h-4 text-white"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 576 512">
                                        <path
                                            d="M96 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L96 64zM464 336l73.5 58.8c4.2 3.4 9.4 5.2 14.8 5.2 13.1 0 23.7-10.6 23.7-23.7l0-240.6c0-13.1-10.6-23.7-23.7-23.7-5.4 0-10.6 1.8-14.8 5.2L464 176 464 336z" />
                                    </svg>
                                </button>
                                <button
                                    id="hb-silver-voice-trash"
                                    type="button"
                                    class="hidden ml-3 w-10 px-3 py-2 text-sm font-medium text-center items-center text-white bg-orange-700 rounded-lg hover:bg-orange-800 focus:ring-4 focus:outline-none focus:ring-orange-300 dark:bg-orange-600 dark:hover:bg-orange-700 dark:focus:ring-orange-800">
                                    <svg
                                        class="w-4 h-4 text-white"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 384 512">
                                        <path
                                            d="M136.7 5.9L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-8.7-26.1C306.9-7.2 294.7-16 280.9-16L167.1-16c-13.8 0-26 8.8-30.4 21.9zM416 144L32 144 53.1 467.1C54.7 492.4 75.7 512 101 512L347 512c25.3 0 46.3-19.6 47.9-44.9L416 144z" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div id="hb-silver-cash" class="hidden">
                            <label
                                for="hb-silver-cash"
                                class="inline-flex justify-between w-full mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Gratuity ℹ️
                                <aside class="inline-flex">
                                    <svg
                                        onclick="alert('Let Miss Aquarius™ AI recommend a Tip Amount based on your written gratitude! (coming soon)')"
                                        class="w-4 h-4 fill-black dark:fill-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7l0 21.4c0 8.8-7.2 16-16 16l-15.8 0c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9c-6.3 7.1-15.3 11.1-24.8 11.1-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7c-6.2-6.2-9.7-14.7-9.7-23.5 0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9l0-27.6c0-8.8 7.2-16 16-16l34.6 0c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z" />
                                    </svg>
                                    <svg
                                        onclick="alert('The Tip Amount you specify will always be publicly visible.')"
                                        class="ml-5 w-4 h-4 fill-green-500"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M351.9 280l-190.9 0c2.9 64.5 17.2 123.9 37.5 167.4 11.4 24.5 23.7 41.8 35.1 52.4 11.2 10.5 18.9 12.2 22.9 12.2s11.7-1.7 22.9-12.2c11.4-10.6 23.7-28 35.1-52.4 20.3-43.5 34.6-102.9 37.5-167.4zM160.9 232l190.9 0C349 167.5 334.7 108.1 314.4 64.6 303 40.2 290.7 22.8 279.3 12.2 268.1 1.7 260.4 0 256.4 0s-11.7 1.7-22.9 12.2c-11.4 10.6-23.7 28-35.1 52.4-20.3 43.5-34.6 102.9-37.5 167.4zm-48 0C116.4 146.4 138.5 66.9 170.8 14.7 78.7 47.3 10.9 131.2 1.5 232l111.4 0zM1.5 280c9.4 100.8 77.2 184.7 169.3 217.3-32.3-52.2-54.4-131.7-57.9-217.3L1.5 280zm398.4 0c-3.5 85.6-25.6 165.1-57.9 217.3 92.1-32.7 159.9-116.5 169.3-217.3l-111.4 0zm111.4-48C501.9 131.2 434.1 47.3 342 14.7 374.3 66.9 396.4 146.4 399.9 232l111.4 0z" />
                                    </svg>
                                </aside>
                            </label>
                            <div class="w-full mx-auto flex">
                                <label
                                    for="hb-silver-cash-amount"
                                    class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">
                                    Tip Amount
                                </label>
                                <div class="relative w-full">
                                    <div
                                        class="absolute inset-y-0 start-0 top-0 flex items-center ps-3.5 pointer-events-none">
                                        <svg
                                            class="w-4 h-4 text-gray-500 dark:text-gray-400"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 20 16">
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M5 2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1M2 5h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm8 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
                                        </svg>
                                    </div>
                                    <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        inputmode="numeric"
                                        pattern="[0-9]*"
                                        autocomplete="off"
                                        id="hb-silver-cash-amount"
                                        class="block p-2.5 w-full z-20 ps-10 text-base text-gray-900 bg-gray-50 rounded-s-lg border-e-gray-50 border-e-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-e-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                                        placeholder="Tip Amount" />
                                </div>
                                <button
                                    id="hb-silver-cash-currency"
                                    class="shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-base font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-e-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600"
                                    type="button">
                                    $ Cash USD
                                </button>
                            </div>
                        </div>
                        <div
                            id="hb-silver-encrypt"
                            class="hidden items-start mt-4 mb-1">
                            <div class="flex items-center h-5">
                                <input
                                    id="hb-silver-encrypt-checkbox"
                                    type="checkbox"
                                    value=""
                                    class="w-4 h-4 border outline-0 border-gray-300 rounded-sm bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800" />
                            </div>
                            <label
                                for="hb-silver-encrypt-checkbox"
                                class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                >Would you like to encrypt your Silver so that
                                only humans can view it?
                            </label>
                        </div>
                        <!--<div
                            id="hb-silver-notify"
                            class="${user
                            ? "flex"
                            : "hidden"} items-start mb-1">
                            <div class="flex items-center h-5">
                                <input
                                    id="hb-silver-notify-checkbox"
                                    type="checkbox"
                                    value=""
                                    checked
                                    class="w-4 h-4 outline-0 border border-gray-300 rounded-sm bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800" />
                            </div>
                            <label
                                for="hb-silver-notify-checkbox"
                                class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                >Would you like HeartBank® to notify the
                                recipients?
                            </label>
                        </div>-->
                    </div>
                    <!-- Modal footer: Etch Signature -->
                    <div
                        class="flex items-center justify-around p-4 md:p-5 border-0 border-gray-200 rounded-b dark:border-gray-600">
                        <button
                            type="submit"
                            class="text-white bg-gray-700 hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
                            Mint Silver B-Chest
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <hb-dialog></hb-dialog>
`;
